import React from 'react';
import { FiActivity, FiBriefcase, FiCalendar, FiTrendingUp } from 'react-icons/fi';

function TimelineStats({ stats, loading }) {
  if (loading) {
    return (
      <div className="timeline-stats-row">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="timeline-stat-card">
            <div className="timeline-skeleton-line short" style={{ width: '100%', height: 44 }} />
          </div>
        ))}
      </div>
    );
  }

  if (!stats) return null;

  // Find top category
  const topCategory = stats.by_category
    ? Object.entries(stats.by_category).sort((a, b) => b[1] - a[1])[0]
    : null;

  const formatDateRange = (range) => {
    if (!range || range.length < 2) return 'N/A';
    const fmt = (d) => {
      try {
        return new Date(d + 'T00:00:00').toLocaleDateString('en-US', {
          month: 'short',
          year: 'numeric',
        });
      } catch {
        return d;
      }
    };
    return `${fmt(range[0])} — ${fmt(range[1])}`;
  };

  return (
    <div className="timeline-stats-row">
      <div className="timeline-stat-card">
        <div className="timeline-stat-icon blue">
          <FiActivity size={22} />
        </div>
        <div className="timeline-stat-info">
          <div className="timeline-stat-value">
            {stats.total_events?.toLocaleString() || 0}
          </div>
          <div className="timeline-stat-label">Total Events</div>
        </div>
      </div>

      <div className="timeline-stat-card">
        <div className="timeline-stat-icon green">
          <FiBriefcase size={22} />
        </div>
        <div className="timeline-stat-info">
          <div className="timeline-stat-value">
            {stats.companies_covered || 0}
          </div>
          <div className="timeline-stat-label">Companies</div>
        </div>
      </div>

      <div className="timeline-stat-card">
        <div className="timeline-stat-icon purple">
          <FiCalendar size={22} />
        </div>
        <div className="timeline-stat-info">
          <div className="timeline-stat-value" style={{ fontSize: 15 }}>
            {formatDateRange(stats.date_range)}
          </div>
          <div className="timeline-stat-label">Date Range</div>
        </div>
      </div>

      <div className="timeline-stat-card">
        <div className="timeline-stat-icon amber">
          <FiTrendingUp size={22} />
        </div>
        <div className="timeline-stat-info">
          <div className="timeline-stat-value" style={{ textTransform: 'capitalize' }}>
            {topCategory ? topCategory[0] : 'N/A'}
          </div>
          <div className="timeline-stat-label">
            Top Category{topCategory ? ` (${topCategory[1]})` : ''}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TimelineStats;
